import { useCallback } from 'react';
import { flushSync } from 'react-dom';
import { useDispatch } from 'react-redux';
import { store } from '../../store/Store';
import { setUserToken } from '../../redux/slices/appInfo/slice';
import { waitForWorkspaceReset } from '../app/session/workspaceResetState';

/**
 * Switch the session to another workspace with a fresh JWT (from `workspaces.switch`, `team.accept`
 * or `team.leave`). `WorkspaceChangeReset` drops the old workspace's data; this hook waits for it.
 */
export function useApplyFreshUserToken(): (token: string) => Promise<void> {
  const dispatch = useDispatch();
  return useCallback(
    async (token: string) => {
      await store.set('userToken', token);
      // `TRPCLoader` builds the tRPC clients from `userToken`, and every query takes its new
      // `queryFn` in an effect of its next render. `flushSync` commits that render, effects
      // included (also the reset in `WorkspaceChangeReset`), before this function goes on.
      flushSync(() => {
        dispatch(setUserToken({ token }));
      });
      await waitForWorkspaceReset();
    },
    [dispatch]
  );
}
